<p-dialog [(visible)]="visivel" [style]="{width: '450px'}" header="TMA" [modal]="true" styleClass="p-fluid" (onHide)="fecharDialog()">
    <ng-template pTemplate="content">
        <div class="formgrid grid p-fluid">
            <div class="field col-12">
              <label for="empresaErp">Empresa ERP: </label>
              <!-- <p-dropdown
                 appendTo="body"
                 [options]="empresas"
                 [filter]="true"
                 optionValue="empresaErp"
                 optionLabel="empresaErp"
                 [(ngModel)]="taxa.deEmpresa"
                 dataKey="id" inputId="id"
                 placeholder="Código Empresa ERP"
                  emptyMessage="Nenhuma código"
                  >
                </p-dropdown> -->
                <app-empresa-dropdown [(selecionadas)]="taxa.deEmpresa" modo="unico" />
            </div>
            <div class="field col-12">
              <label for="datainicial">Data Inicial: </label>
              <p-inputMask
                type="text"
                id="datainicial"
                mask="99/99/9999"
                [(ngModel)]="taxa.dataInicial"
              />
            </div>
            <div class="field col-12">
              <label for="datafinal">Data Final: </label>
              <p-inputMask
                type="text"
                id="datafinal"
                
                mask="99/99/9999"
                
                [(ngModel)]="taxa.dataFinal"
                
              />
            </div>
            <div class="field col-12">
              <label for="taxa">Taxa: </label>
              <p-inputNumber
                type="text"
                id="taxa"
                mode="decimal"
                [minFractionDigits]="2"
                [maxFractionDigits]="5"
                [(ngModel)]="taxa.taxa"
                
              />
            </div>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
       <!-- <button pButton label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="fecharDialog()"></button>
       <button pButton label="Salvar" icon="pi pi-check" class="p-button-text" (click)="salvar()"></button> -->

       <button
       pButton label="Cancelar"
       icon="pi pi-times"
       class="p-button-text"
       (click)="fecharDialog()"></button>
       <button
                pButton
                icon="pi pi-save"
                class="p-button-success"
                [label]="taxa.id ? 'Atualizar' : 'Salvar'"
                (click)="salvar()"
              ></button>
   </ng-template>
   </p-dialog>